module.exports = {"361103001":"永丰街道","361103002":"芦林街道","361103003":"丰溪街道","361103004":"下溪街道","361103005":"大石街道","361103101":"五都镇","361103102":"洋口镇","361103103":"横山镇","361103104":"桐畈镇","361103105":"湖丰镇","361103106":"大南镇","361103107":"排山镇","361103108":"毛村镇","361103109":"枧底镇","361103110":"泉波镇","361103111":"壶峤镇","361103112":"霞峰镇","361103114":"吴村镇","361103115":"沙田镇","361103116":"铜钹山镇","361103202":"东阳乡","361103204":"嵩峰乡","361103206":"少阳乡","361103500":"铜拔山垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361103.json
// module id = 1239
// module chunks = 0